<template>
    <div class="sharemask">
        <img
            src="@/assets/20191126152123560.png"
            width="250px;"
            class="bg"
        >
        <img
            src="@/assets/20191126152108706.png"
            width="180px"
            class="now"
            @click="onRemove"
        >
    </div>
</template>
<script setup>
    const emits = defineEmits(['onhide']);
    const onRemove = () =>
    {
		emits("onhide")
    }
</script>
<style scoped>
    .bg {
        width: 500px;
    }

    .now {
        width: 360px;
    }

    .sharemask {
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        width: 100%;
        height: 100%;
        z-index: 999;
        display: flex;
        position: fixed;
        align-items: flex-end;
        flex-direction: column;
        background: rgba(0, 0, 0, 0.9);
    }

    .sharemask img:nth-child(2) {
        margin-top: .5rem;
        margin-right: 1rem;
    }

    .sharemask img:nth-child(1) {
        margin-right: .5rem;
    }

    .dev_share {
        margin-top: 5rem;
        margin-left: 1.75rem;
        box-shadow: 0px 0px 5px rgba(200, 200, 200, 0.5);
        border-radius: .5rem;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #ffffff;
        width: 4.3rem;
        height: .7rem;
        color: #3297ff;
        font-size: .28rem;
        border: .02rem solid #3297ff;
    }

    .lockbody {
        /*锁定屏幕不滚动*/
        position: fixed;
        overflow: hidden;
    }
</style>